var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2071 0.792893C12.5976 0.402369 13.2308 0.402369 13.6213 0.792893L15.2071 2.37868C15.5976 2.76921 15.5976 3.40237 15.2071 3.79289L14.6213 4.37868L11.6213 1.37868L12.2071 0.792893ZM10.9142 2.08579L13.9142 5.08579L5.70711 13.2929C5.51957 13.4804 5.26522 13.5858 5 13.5858H2C1.44772 13.5858 1 13.1381 1 12.5858V9.58579C1 9.32057 1.10536 9.06621 1.29289 8.87868L9.5 0.671573L10.9142 2.08579ZM2 9.99999V12H4.00001L11.0858 4.91421L9.08579 2.91421L2 9.99999Z",
    fill: "#05ACD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.6388ad864b61db4e25aeb0a3416d7ffc.svg";
export { ForwardRef as ReactComponent };